"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _lodash = require("lodash");

var _Input = _interopRequireDefault(require("./Input"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _Tag = _interopRequireDefault(require("./Tag"));

var _utils = require("../utils");

var _redux = require("../redux");

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Menu = function Menu(props) {
  var _site$postTypes;

  var onAdd = props.onAdd;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      site = _ref.cms.site;

  var _ref2 = (0, _react.useState)('page'),
      _ref3 = _slicedToArray(_ref2, 2),
      filter = _ref3[0],
      setFilter = _ref3[1];

  var _ref4 = (0, _react.useState)({
    title: '',
    url: ''
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      link = _ref5[0],
      setLink = _ref5[1]; // Get posts by filter


  var postType = site === null || site === void 0 ? void 0 : (_site$postTypes = site.postTypes) === null || _site$postTypes === void 0 ? void 0 : _site$postTypes[filter];
  var posts = postType !== null && postType !== void 0 && postType.posts ? Object.values(postType.posts) : []; // Sort posts by menu order

  posts = posts.sort(function (a, b) {
    return a.order > b.order ? 1 : -1;
  }); // Create data tree

  posts = (0, _utils.createDataTree)(posts);

  var handleAddLink = function handleAddLink() {
    if (!link.title || !link.url) {
      return;
    }

    onAdd(_objectSpread(_objectSpread({
      key: (0, _utils.generateRandomString)()
    }, link), {}, {
      postTypeID: null,
      postID: null,
      children: []
    }));
    setLink({
      title: '',
      url: ''
    });
  };

  var renderPost = function renderPost(o, level) {
    var _site$languages, _o$translations;

    var slug = (0, _utils.generateSlug)({
      site: site,
      postTypeID: postType.id,
      postID: o.id,
      leadingSlash: true
    });
    var badges = [];

    if ((site === null || site === void 0 ? void 0 : site.frontPage) === o.id || site !== null && site !== void 0 && (_site$languages = site.languages) !== null && _site$languages !== void 0 && _site$languages.defaultLanguage && (o === null || o === void 0 ? void 0 : (_o$translations = o.translations) === null || _o$translations === void 0 ? void 0 : _o$translations[site.languages.defaultLanguage]) === (site === null || site === void 0 ? void 0 : site.frontPage)) {
      badges.push( /*#__PURE__*/_react.default.createElement(_Tag.default, {
        key: "front",
        children: 'front'
      }));
    }

    if (o.status === 'draft' || o.status === 'trash') {
      badges.push( /*#__PURE__*/_react.default.createElement(_Tag.default, {
        key: "status",
        children: o.status
      }));
    }

    var actions = [];
    o.status === 'publish' && actions.push( /*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "add",
      onClick: function onClick() {
        return onAdd({
          key: (0, _utils.generateRandomString)(),
          title: o.title,
          postTypeID: o.postTypeID,
          postID: o.id,
          children: [],
          url: (0, _utils.generateSlug)({
            site: site,
            postTypeID: postType.id,
            postID: o.id,
            leadingSlash: true
          })
        });
      }
    }, "Add"));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: o.id
    }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      level: level,
      title: o.title,
      subtitle: slug,
      status: badges,
      showImage: false,
      disabled: o.status === 'draft',
      actions: actions
    }), o.childNodes.map(function (p) {
      return renderPost(p, level + 1);
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: filter,
    onChange: function onChange(v) {
      return setFilter(v);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'page',
    tab: 'PAGE'
  }), Object.values(site === null || site === void 0 ? void 0 : site.postTypes).filter(function (o) {
    return o.id !== 'page';
  }).map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      key: o.id,
      tab: o.id.toUpperCase()
    });
  }), /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
    key: 'link',
    tab: 'LINK'
  })), /*#__PURE__*/_react.default.createElement("div", null, filter === 'link' ? /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: link.title,
    onChange: function onChange(e) {
      return setLink(_objectSpread(_objectSpread({}, link), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Url",
    value: link.url,
    onChange: function onChange(e) {
      return setLink(_objectSpread(_objectSpread({}, link), {}, {
        url: e.target.value
      }));
    },
    placeholder: "https://"
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    style: {
      marginBottom: 20
    },
    children: "Add",
    type: "primary",
    onClick: handleAddLink
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _lodash.isEmpty)(posts) ? /*#__PURE__*/_react.default.createElement(EmptyContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    imageStyle: {
      height: 120
    }
  })) : /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 4
  }, posts.filter(function (o) {
    return o.status !== 'trash';
  }).map(function (p) {
    return renderPost(p, 0);
  })))));
};

var EmptyContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  text-align: center;\n"])));

var _default = Menu;
exports.default = _default;